<template>
  <div class="form-confirm-comment">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('contacts.comment.form_confirm_comment.title') }}
        </p>
      </div>
      <div class="last-message" v-if="lastMessage">
        <div class="child">
          <p id="idLineContact" ref="idLineContact" class="whitespace-pre-line" :class="showAll ? '' : 'not-show-all'" v-html="lastMessage"></p>
          <span v-if="showLine>3" class="btn-show" @click="handleShowLastMessage">
            {{ showAll ? '▲' + $t('contacts.not_show_all') : '▼' + $t('contacts.show_all') }}
          </span>
        </div>
      </div>
      <div class="main">
        <div class="child">
          <p class="message whitespace-pre-line" v-html="message"></p>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" @click="send" class="btn btn-send">{{ $t('contacts.comment.form_confirm_comment.btn_send') }}</el-button>
        <el-button type="primary" @click="back" class="btn btn-back">{{ $t('contacts.comment.form_confirm_comment.btn_back') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { sendMessage } from '../../api/contact'

  export default {
    props: {
      openFormConfirmComment: { type: Boolean, required: true, default: false },
      urls: { type: Object, required: true, default: {} },
      lastMessage: { type: String, required: true, default: '' },
      message: { type: String, required: true, default: '' },
      contactId: { type: Number, required: true, default: 0 },
      site: { type: Number, required: false}
    },
    emits: ['isClosePopupConfirmComment', 'sendMessageComplete'],
    data() {
      return {
        dialog: false,
        loading: false,
        showAll: false,
        showLine: 0,
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupConfirmComment');
      },
      send() {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        sendMessage(this.urls.send, this.message)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === this.$httpStatus.success) {
            const status = (this.site === this.$siteType.site_partner) ? this.$statusContact.reply_from_user : this.$statusContact.reply_from_admin;
            this.$emit('sendMessageComplete', status);
          }
        })
      },

      back() {
        this.handleClose();
      },

      handleShowLastMessage() {
        this.showAll = !this.showAll;
      }
    },
    created() {
      this.dialog = this.openFormConfirmComment;
    },
    mounted(){
      this.$nextTick(()=>{
        this.showLine = Math.floor((this.$refs.idLineContact.scrollHeight)/28);
      });
    }
  }
</script>

<style lang="scss">
  .form-confirm-comment {
    text-align: center !important;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700
    }
    .el-dialog {
      --el-dialog-width: 760px;
      --el-dialog-margin-top: 10vh;
      .el-dialog__body {
        height: 610px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0;
          background: transparent;
        }
      }
    }
    .last-message {
      padding: 0 48px;
      .child {
        width: 100%;
        margin: 0 auto;
        text-align: left;
        border-left: solid 1px #DDD8D1;
        padding-left: 15px;
        .not-show-all {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0;
        }
        p {
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          line-height: 28px;
          margin: 0;
          color: #000;
        }
        .btn-show {
          color: #17609F;
          cursor: pointer;
          padding-top: 6px;
          display: inline-block;
        }
      }
    }
    .main {
      padding: 0 48px;
      .child {
        width: 100%;
        letter-spacing: 0.75px;
        color: #000000;
        text-align: left;
        position: relative;
        padding: 0;
        .message {
          padding: 15px;
          background: #F7F3ED 0% 0% no-repeat padding-box;
          height: 220px;
          box-shadow: 0px 1px 4px #00000029;
          border: 1px solid #DDD8D1;
          overflow-y: auto;
          margin: 25px 0 0;
          letter-spacing: 1.3px;
          line-height: 29px;
        }
        &:after {
          content: "";
          position: absolute;
          top: 15px;
          right: 15px;
          width: 2px;
          background: #DDD8D1;
          height: 150px;
        }
      }
    }
    .footer {
      margin-top: 35px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
        margin-left: 25px;
        &:first-child {
          margin-left: 0;
        }
      }
      .btn-send {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
      }
    }
  }
</style>
